import React from "react";

const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-[#02050e] relative z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex items-center gap-2">
          <span className="material-symbols-outlined text-primary">
            terminal
          </span>
          <span className="font-display font-bold text-xl">Sakib</span>
        </div>
        <div className="flex gap-8 text-sm text-gray-400">
          <a
            className="hover:text-white transition-colors"
            href="https://www.linkedin.com/in/nazmus-sakib-anik"
          >
            LinkedIn
          </a>
          <a
            className="hover:text-white transition-colors"
            href="https://github.com/Sakib8git"
          >
            GitHub
          </a>
          <a
            className="hover:text-white transition-colors"
            href="https://www.facebook.com/sakib30278"
          >
            Email
          </a>
        </div>
        <p className="text-xs text-gray-600">
          © 2026 Nazmus Sakib. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
